import React, { FC } from 'react';
import classnames from 'classnames';
import '@eika/toggle-switch-style';

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (value: boolean) => void;
    ariaLabel?: string;
    disabled?: boolean;
}

const ToggleSwitch: FC<ToggleSwitchProps> = ({ checked, onChange, ariaLabel, disabled }) => {
    return (
        <label className="sgw-toggle-switch">
            <div className="sgw-toggle-switch__label">{checked ? 'På' : 'Av'}</div>
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                aria-label={ariaLabel}
                className={classnames('sgw-toggle-switch__button', { checked })}
                onClick={() => onChange(!checked)}
                disabled={disabled}
            >
                <span aria-hidden="true" className="sgw-toggle-switch__circle" />
            </button>
        </label>
    );
};

export default ToggleSwitch;
